<ion-header class="m-size-filter-header">
  <ion-row class="ion-align-items-center ion-justify-content-between header">
    <div>{{ 'size_filter.selectSizes' | translate }}</div>
    <ion-item class="select-all">
      <ion-checkbox slot="end" [checked]="isAllSelected" (ionChange)="selectAll($event)"></ion-checkbox>
      <ion-label>{{ 'size_filter.selectAll' | translate }}</ion-label>
    </ion-item>
  </ion-row>
</ion-header>
<ion-content class="m-size-filter-content">
  <ion-row>
    <ion-col *ngFor="let item of sizeList; let i = index" size="4">
      <ion-item class="size-item">
        <ion-checkbox slot="end" [checked]="filteredList[i]" (ionChange)="handleOnChange($event, i)"></ion-checkbox>
        <ion-label>{{ item.name }}</ion-label>
      </ion-item>
    </ion-col>
  </ion-row>
</ion-content>
<ion-footer>
  <ion-row class="m-size-filter-footer">
    <ion-col class="cancel" (click)="handleCancel()">{{ 'input_app_common.cancel' | translate }}</ion-col>
    <ion-col class="save" [ngClass]="{ 'save--disabled': !isAnySizeSelected }" (click)="handleSave()">
      {{ 'input_app_common.save' | translate }}
    </ion-col>
  </ion-row>
</ion-footer>
